import { render, staticRenderFns } from "./OrdersWeighingModule.vue?vue&type=template&id=47a57817&"
import script from "./OrdersWeighingModule.vue?vue&type=script&lang=js&"
export * from "./OrdersWeighingModule.vue?vue&type=script&lang=js&"
import style0 from "./OrdersWeighingModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports